// RAC validation for the jsa information

// RAC validation will really only validate the dropdown fields for the RAC Code section
export const validateJsaRac = (jsaRac) => {
  const errors = {};
  const racCodeOptions = ["E", "H", "M", "L"];
  // Validating each of the RAC Code fields

  if (jsaRac.racAccessCode && jsaRac.racAccessCode.trim() !== "") {
    if (!racCodeOptions.includes(jsaRac.racAccessCode)) {
      errors.racAccessPotHazInfo = "RAC Accesss Code is not valid";
    }
  }

  if (jsaRac.racChemicalCode && jsaRac.racChemicalCode.trim() !== "") {
    if (!racCodeOptions.includes(jsaRac.racChemicalCode)) {
      errors.racChemicalCode = "RAC Chemical Code is not valid";
    }
  }

  if (jsaRac.racEnvironmentCode && jsaRac.racEnvironmentCode.trim() !== "") {
    if (!racCodeOptions.includes(jsaRac.racEnvironmentCode)) {
      errors.racEnvironmentCode = "RAC Environment Code is not valid";
    }
  }

  if (jsaRac.racPhysicalCode && jsaRac.racPhysicalCode.trim() !== "") {
    if (!racCodeOptions.includes(jsaRac.racPhysicalCode)) {
      errors.racPhysicalCode = "RAC Physical Code is not valid";
    }
  }

  if (jsaRac.racPotEnergyCode && jsaRac.racPotEnergyCode.trim() !== "") {
    if (!racCodeOptions.includes(jsaRac.racPotEnergyCode)) {
      errors.racPotEnergyCode = "RAC Pot Energy Code is not valid";
    }
  }

  if (jsaRac.racToolsCode && jsaRac.racToolsCode.trim() !== "") {
    if (!racCodeOptions.includes(jsaRac.racToolsCode)) {
      errors.racToolsCode = "RAC Tools Code is not valid";
    }
  }

  if (jsaRac.racOtherCode && jsaRac.racOtherCode.trim() !== "") {
    if (!racCodeOptions.includes(jsaRac.racOtherCode)) {
      errors.racOtherCode = "RAC Other Code is not valid";
    }
  }

  return errors;
};
